import React from 'react';
import logo from '../assets/Tremont Garden Logo.png';

const Footer = () => {
  return (
    <footer className="bg-gray-200 p-4 mt-8">
      <div className="max-w-[1120px] mx-auto px-4 w-full flex items-center justify-center">
        <a href="https://tremontgarden.com" className="flex items-center">
          <img src={logo} alt="Tremont Garden Logo" className="h-8 mr-4" />
          <p>&copy; {new Date().getFullYear()} Tremont Garden.</p>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
